/* eslint-disable no-await-in-loop */
/* eslint-disable prefer-destructuring */
/* eslint-disable func-names */
/* eslint-disable no-undef */

import {getOnePageApiPages, listFieldsDatabase, listMethodPaymentProject} from 'api-lofty';
import {
  databaseFieldsGetComponent,
  databaseFieldsPostComponent,
  getAllReadRelationFieldsForParams,
  getForeignFields,
  getRelationInfo,
} from '../../util/databaseFieldsComponent';
import {restoreComponentToDefault} from '../../util/grapeJsCanvasFunctions';
import {searchForReadDB} from '../../util/searchParentComponent';
// import {getAllReadFieldsForParams} from '../../util/databaseFieldsComponent';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const defaultType = dc.getType('default');
  const defaultView = defaultType.view;

  function handleButtonClickOpenManager(info, model) {
    const {handleInputManager} = opts;
    // console.log(openForm);
    handleInputManager(info, model);
  }

  async function getMainData(relationArray, token, idProject) {
    const retVal = [];
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < relationArray.length; index++) {
      const tempRelation = await getRelationInfo(relationArray[index], token, idProject);
      const tempFields = await getForeignFields(relationArray[index], token, idProject);
      retVal[relationArray[index]] = {};
      retVal[relationArray[index]].fields = tempFields;
      retVal[relationArray[index]].data = tempRelation;
    }
    return retVal;
  }

  async function getPaymentMethods(model) {
    const token = opts.token;
    const idProject = opts.idProject;
    const getPageData = await getOnePageApiPages({token, _id: opts.idPage});
    const resMethod = await listMethodPaymentProject({project: idProject, token});
    const optionsData = [];
    let filterData = [];
    if (getPageData.data.authProtocol === 'active' || getPageData.data.authProtocol === 'not required') {
      filterData = resMethod.data.filter((index) => (index?.haveAuth));
    } else {
      filterData = resMethod.data;
    }
    filterData.forEach((index) => {
      optionsData.push({
        name: index.label,
        value: index._id,
        objectData: index,
      });
    });
    const defaultValue = model.attributes.methodPayFunction || '';
    const traitPaymentMethods = {
      type: 'select',
      name: 'methodPayFunction',
      label: 'Metodo de Pago',
      changeProp: 1,
      options: optionsData,
      default: defaultValue,
    };
    model.addTrait(traitPaymentMethods);
  }

  async function getFieldsFromPayDatabase(model, databaseId) {
    const token = opts.token;
    const idProject = opts.idProject;
    const resFields = await listFieldsDatabase({idProject, token, idDatabase: databaseId});
    const listRelations = [];
    const relationData = [];
    resFields.data.forEach((index) => {
      if (index.type === 'relation') {
        listRelations.push(index.relationDatabase);
        relationData.push(index);
      }
    });
    const filterFields = resFields.data.filter((index) => (index.type !== 'cartArray' && index.type !== 'arrayDatabase' && index.type !== 'user'));
    const dataCaptureInfo = await getMainData(listRelations, token, idProject);
    const resFieldsReact = databaseFieldsPostComponent(filterFields, [], dataCaptureInfo);
    let htmlAdder = '<form data-gjs-resizable="{bc: 1}" style="padding: 10px;" data-gjs-slugLofty="formPayCart" data-gjs-name="Formulario Carrito" title="addFormDatabase">';
    htmlAdder += `
    ${resFieldsReact}
    <button
      type="submit"
      data-gjs-slugLofty="formAddDatabaseButton"
      data-gjs-name="Boton Agregar a Coleccion de Datos"
      data-gjs-resizable="{bc: 1}"
    >
      <div data-gjs-resizable="{bc: 1}" data-gjs-slugLofty="standardButtonText" data-gjs-name="Texto Estandar de Boton" data-gjs-draggable="false">Submit</div>
    </button>
    </form>
    `;
    model.append(htmlAdder);
    const resPage = await getOnePageApiPages({token, _id: opts.idPage});
    const urlParamsRaw = resPage.data.url.split('/');
    let hasParams = false;
    const filterParams = [];
    urlParamsRaw.forEach((index) => {
      if (index.includes(':')) {
        hasParams = true;
        const temp = index.split(':');
        const paramData = temp[1];
        filterParams.push({value: paramData, name: paramData});
      }
    });
    if (hasParams && relationData.length > 0) {
      const relationTraitInfo = [];
      relationData.forEach((index) => {
        relationTraitInfo.push({relationInput: index, state: 'input'});
      });
      const traitUseParamForRelation = {
        type: 'button',
        text: 'Manejar Inputs de Relaciones',
        name: 'buttonRelationInputManager',
        full: true,
        command: () => handleButtonClickOpenManager(filterParams, model),
      };
      model.addTrait(traitUseParamForRelation);
      model.addAttributes({relationInputs: relationTraitInfo});
    }
  }

  async function getFieldsForPayServiceDatabase(model, databaseId) {
    const token = opts.token;
    const idProject = opts.idProject;
    const resFields = await listFieldsDatabase({idProject, token, idDatabase: databaseId});
    const listRelations = [];
    const relationData = [];
    resFields.data.forEach((index) => {
      if (index.type === 'relation') {
        listRelations.push(index.relationDatabase);
        relationData.push(index);
      }
    });
    const filterFields = resFields.data.filter((index) => (index.type !== 'cartArray' && index.type !== 'arrayDatabase' && index.type !== 'user'));

    const dataCaptureInfo = await getMainData(listRelations, token, idProject);
    const resFieldsReact = databaseFieldsPostComponent(filterFields, [], dataCaptureInfo);
    let htmlAdder = '<form data-gjs-resizable="{bc: 1}" style="padding: 10px;" data-gjs-slugLofty="formPayService" data-gjs-name="Formulario Pago Servicio" title="addFormDatabase">';
    htmlAdder += `
    ${resFieldsReact}
    <button
      type="submit"
      data-gjs-slugLofty="formAddDatabaseButton"
      data-gjs-name="Boton Agregar a Coleccion de Datos"
      data-gjs-resizable="{bc: 1}"
    >
      <div data-gjs-resizable="{bc: 1}" data-gjs-slugLofty="standardButtonText" data-gjs-name="Texto Estandar de Boton" data-gjs-draggable="false">Submit</div>
    </button>
    </form>
    `;
    model.append(htmlAdder);

    // Relation state
    model.append(htmlAdder);
    const resPage = await getOnePageApiPages({token, _id: opts.idPage});
    const urlParamsRaw = resPage.data.url.split('/');
    let hasParams = false;
    const filterParams = [];
    urlParamsRaw.forEach((index) => {
      if (index.includes(':')) {
        hasParams = true;
        const temp = index.split(':');
        const paramData = temp[1];
        filterParams.push({value: paramData, name: paramData});
      }
    });
    if (hasParams && relationData.length > 0) {
      const relationTraitInfo = [];
      relationData.forEach((index) => {
        relationTraitInfo.push({relationInput: index, state: 'input'});
      });
      const traitUseParamForRelation = {
        type: 'button',
        text: 'Manejar Inputs de Relaciones',
        name: 'buttonRelationInputManager',
        full: true,
        command: () => handleButtonClickOpenManager(filterParams, model),
      };
      model.addTrait(traitUseParamForRelation);
      model.addAttributes({relationInputs: relationTraitInfo});
    }
  }

  async function getFieldsForPayServiceDatabaseOnLoad(model, databaseId) {
    const token = opts.token;
    const idProject = opts.idProject;
    const resFields = await listFieldsDatabase({idProject, token, idDatabase: databaseId});
    const listRelations = [];
    const relationData = [];
    resFields.data.forEach((index) => {
      if (index.type === 'relation') {
        listRelations.push(index.relationDatabase);
        relationData.push(index);
      }
    });

    const resPage = await getOnePageApiPages({token, _id: opts.idPage});
    const urlParamsRaw = resPage.data.url.split('/');
    let hasParams = false;
    const filterParams = [];
    urlParamsRaw.forEach((index) => {
      if (index.includes(':')) {
        hasParams = true;
        const temp = index.split(':');
        const paramData = temp[1];
        filterParams.push({value: paramData, name: paramData});
      }
    });
    if (hasParams && relationData.length > 0) {
      const relationTraitInfo = [];
      relationData.forEach((index) => {
        relationTraitInfo.push({relationInput: index, state: 'input'});
      });
      const traitUseParamForRelation = {
        type: 'button',
        text: 'Manejar Inputs de Relaciones',
        name: 'buttonRelationInputManager',
        full: true,
        command: () => handleButtonClickOpenManager(filterParams, model),
      };
      model.addTrait(traitUseParamForRelation);
      model.addAttributes({relationInputs: relationTraitInfo});
    }
  }

  async function getFieldsListCollection(model, databaseId) {
    const token = opts.token;
    const idProject = opts.idProject;
    const resFields = await listFieldsDatabase({idProject, token, idDatabase: databaseId});
    const listRelations = [];
    const relationData = [];
    resFields.data.forEach((index) => {
      if (index.type === 'relation') {
        listRelations.push(index.relationDatabase);
        relationData.push(index);
      }
    });
    const filterFields = resFields.data.filter((index) => (index.type !== 'cartArray' && index.type !== 'arrayDatabase' && index.type !== 'user'));
    const dataCaptureInfo = await getMainData(listRelations, token, idProject);
    const resFieldsReact = databaseFieldsPostComponent(filterFields, [], dataCaptureInfo);
    let htmlAdder = '<form data-gjs-resizable="{bc: 1}" style="padding: 10px;" data-gjs-slugLofty="formListCollection" data-gjs-name="Formulario Lista de Coleccion" title="addFormDatabase">';
    htmlAdder += `
    <div data-gjs-slugLofty="itemListEndpointDatabase" data-gjs-name="Item List Read" style="padding: 10px;" >
    ${resFieldsReact}
    </div>
    <button
      type="submit"
      data-gjs-slugLofty="formAddDatabaseButton"
      data-gjs-name="Boton Agregar a Coleccion de Datos"
      data-gjs-resizable="{bc: 1}"
    >
      <div data-gjs-resizable="{bc: 1}" data-gjs-slugLofty="standardButtonText" data-gjs-name="Texto Estandar de Boton" data-gjs-draggable="false">Submit</div>
    </button>

    </form>
    `;
    model.append(htmlAdder);
    // Relation state
    model.append(htmlAdder);
    const resPage = await getOnePageApiPages({token, _id: opts.idPage});
    const urlParamsRaw = resPage.data.url.split('/');
    let hasParams = false;
    const filterParams = [];
    urlParamsRaw.forEach((index) => {
      if (index.includes(':')) {
        hasParams = true;
        const temp = index.split(':');
        const paramData = temp[1];
        filterParams.push({value: paramData, name: paramData});
      }
    });
    if (hasParams && relationData.length > 0) {
      const relationTraitInfo = [];
      relationData.forEach((index) => {
        relationTraitInfo.push({relationInput: index, state: 'input'});
      });
      const traitUseParamForRelation = {
        type: 'button',
        text: 'Manejar Inputs de Relaciones',
        name: 'buttonRelationInputManager',
        full: true,
        command: () => handleButtonClickOpenManager(filterParams, model),
      };
      model.addTrait(traitUseParamForRelation);
      model.addAttributes({relationInputs: relationTraitInfo});
    }
  }

  async function getFieldsUpdateService(model, databaseId) {
    const token = opts.token;
    const idProject = opts.idProject;
    const resFields = await listFieldsDatabase({idProject, token, idDatabase: databaseId});
    const filterFields = resFields.data.filter((index) => (index.type !== 'cartArray' && index.type !== 'arrayDatabase' && index.type !== 'user'));
    const resFieldsReact = databaseFieldsGetComponent(filterFields);
    let htmlAdder = '<form data-gjs-resizable="{bc: 1}" style="padding: 10px;" data-gjs-slugLofty="formUpdateService" data-gjs-name="Formulario Actualizar Servicio" title="addFormDatabase">';
    htmlAdder += `
    ${resFieldsReact}
    <button
      type="submit"
      data-gjs-slugLofty="formAddDatabaseButton"
      data-gjs-name="Boton Agregar a Coleccion de Datos"
      data-gjs-resizable="{bc: 1}"
    >
      <div data-gjs-resizable="{bc: 1}" data-gjs-slugLofty="standardButtonText" data-gjs-name="Texto Estandar de Boton" data-gjs-draggable="false">Submit</div>
    </button>

    </form>
    `;
    model.append(htmlAdder);
  }

  async function getVariables(model, originId) {
    const varData = [];
    const localVars = opts.localVars;
    const globalVars = opts.globalVars;
    localVars.filter((index) => (index.type === 'cartArray' && index.idDatabase === originId))
      .forEach((variable) => {
        varData.push({name: `${variable.label}--local`, value: variable._id, originId: variable.idDatabase});
      });
    globalVars.filter((index) => (index.typeValue === 'cartArray' && index.idDatabase === originId))
      .forEach((variable) => {
        varData.push({name: `${variable.label}--global`, value: variable._id, originId: variable.idDatabase});
      });
    const traitAddition = {
      type: 'select',
      name: 'cartMethodPay',
      label: 'Variable para Carrito',
      changeProp: 1,
      options: varData,
      default: model?.attributes?.cartMethodPay,
    };
    model.addTrait(traitAddition);
  }

  async function getListVariables(model, originId) {
    const varData = [];
    const localVars = opts.localVars;
    const globalVars = opts.globalVars;
    localVars.filter((index) => (index.type === 'arrayDatabase' && index.idDatabase === originId))
      .forEach((variable) => {
        varData.push({name: `${variable.label}--local`, value: variable._id, originId: variable.idDatabase});
      });
    globalVars.filter((index) => (index.typeValue === 'arrayDatabase' && index.idDatabase === originId))
      .forEach((variable) => {
        varData.push({name: `${variable.label}--global`, value: variable._id, originId: variable.idDatabase});
      });
    const traitAddition = {
      type: 'select',
      name: 'listVariablesPay',
      label: 'Variable para Listado',
      changeProp: 1,
      options: varData,
      default: model?.attributes?.listVariablesPay,
    };
    model.addTrait(traitAddition);
  }

  async function getPossibleVarsReadAndParam(model, originId) {
    const varData = [];
    const token = opts.token;
    const idPage = opts.idPage;
    const idProject = opts.idProject;

    // VARIABLES
    const localVars = opts.localVars;
    const globalVars = opts.globalVars;
    localVars.filter((index) => (index.type === 'database' && index.idDatabase === originId))
      .forEach((variable) => {
        varData.push({
          name: `${variable.label}--variable--local`,
          value: variable._id,
          originId: variable.idDatabase,
          typeData: 'var',
        });
      });
    globalVars.filter((index) => (index.typeValue === 'database' && index.idDatabase === originId))
      .forEach((variable) => {
        varData.push({
          name: `${variable.label}--variable--global`,
          value: variable._id,
          originId: variable.idDatabase,
          typeData: 'var',
        });
      });

    // PARAMS
    const resPage = await getOnePageApiPages({token, _id: idPage});
    const urlParamsRaw = resPage.data.url.split('/');
    urlParamsRaw.forEach((index) => {
      if (index.includes(':')) {
        const temp = index.split(':');
        const paramData = temp[1];
        varData.push({value: paramData, name: `${paramData} -- parametro`, typeData: 'param'});
      }
    });

    // READER
    const findReadDBParent = searchForReadDB(model);
    const filterOptionsData = await getAllReadRelationFieldsForParams(
      findReadDBParent,
      token,
      idProject,
    );
    filterOptionsData?.forEach((index) => {
      varData.push({value: index.value, name: `${index.name} -- Campo`, typeData: 'field'});
    });
    const traitAddition = {
      type: 'select',
      name: 'serviceVarManage',
      label: 'Manejar por',
      changeProp: 1,
      options: varData,
      default: model?.attributes?.serviceVarManage,
    };
    model.addTrait(traitAddition);
  }

  async function captureFieldForVars(model, idField, idDatabase) {
    const token = opts.token;
    const idProject = opts.idProject;
    const resFields = await listFieldsDatabase({idProject, token, idDatabase});
    const filterByID = resFields.data.find((index) => (index._id === idField));
    getVariables(model, filterByID?.relationDatabase);
  }

  async function captureInfoForService(model, idField, idDatabase) {
    const token = opts.token;
    const idProject = opts.idProject;
    const resFields = await listFieldsDatabase({idProject, token, idDatabase});
    const filterByID = resFields.data.find((index) => (index._id === idField));
    getPossibleVarsReadAndParam(model, filterByID?.relationDatabase);
  }

  async function captureInfoForList(model, idField, idDatabase) {
    const token = opts.token;
    const idProject = opts.idProject;
    const resFields = await listFieldsDatabase({idProject, token, idDatabase});
    const filterByID = resFields.data.find((index) => (index._id === idField));
    getListVariables(model, filterByID?.relationDatabase);
  }

  async function SeekInformationForFields(model) {
    const getSelectedData = model.getTrait('methodPayFunction').attributes.value;
    const getOption = model.getTrait('methodPayFunction').attributes.options;
    const filterData = getOption.find((obj) => (obj.value === getSelectedData));
    if (filterData?.objectData?.type === 'createOrderShoppingcart') {
      getFieldsFromPayDatabase(model, filterData.objectData?.idDatabase);
      captureFieldForVars(
        model,
        filterData.objectData?.shoppingCartField,
        filterData.objectData?.idDatabase,
      );
    } else if (filterData?.objectData?.type === 'createService') {
      getFieldsForPayServiceDatabase(model, filterData.objectData?.idDatabase);
      captureInfoForService(
        model,
        filterData.objectData?.updateStatusField,
        filterData.objectData?.idDatabase,
      );
    } else if (filterData?.objectData?.type === 'listCollection') {
      getFieldsListCollection(model, filterData.objectData?.idDatabase);
      captureInfoForList(
        model,
        filterData.objectData?.listCollectionField,
        filterData.objectData?.idDatabase,
      );
    } else if (filterData?.objectData?.type === 'updateStatusService') {
      getFieldsUpdateService(model, filterData.objectData?.idDatabase);
      captureInfoForService(
        model,
        filterData.objectData?.updateStatusField,
        filterData.objectData?.idDatabase,
      );
    }
  }

  async function RestoreVarData(model) {
    const getSelectedData = model.attributes.methodPayFunction;
    const getOption = model.getTrait('methodPayFunction').attributes.options;
    const filterData = getOption.find((obj) => (obj.value === getSelectedData));
    if (filterData?.objectData?.type === 'createOrderShoppingcart') {
      getFieldsForPayServiceDatabaseOnLoad(model, filterData.objectData?.idDatabase);
      captureFieldForVars(
        model,
        filterData.objectData?.shoppingCartField,
        filterData.objectData?.idDatabase,
      );
    } else if (filterData?.objectData?.type === 'createService') {
      getFieldsForPayServiceDatabaseOnLoad(model, filterData.objectData?.idDatabase);
      captureInfoForService(
        model,
        filterData.objectData?.updateStatusField,
        filterData.objectData?.idDatabase,
      );
    } else if (filterData?.objectData?.type === 'listCollection') {
      getFieldsForPayServiceDatabaseOnLoad(model, filterData.objectData?.idDatabase);
      captureInfoForList(
        model,
        filterData.objectData?.listCollectionField,
        filterData.objectData?.idDatabase,
      );
    } else if (filterData?.objectData?.type === 'updateStatusService') {
      getFieldsForPayServiceDatabaseOnLoad(model, filterData.objectData?.idDatabase);
      captureInfoForService(
        model,
        filterData.objectData?.updateStatusField,
        filterData.objectData?.idDatabase,
      );
    }
  }

  dc.addType(opts.name, {
    model: {
      defaults: {
        traits: [],
      },
    },

    // eslint-disable-next-line consistent-return
    isComponent: (el) => {
      try {
        const attr = el.attributes;
        if (attr['data-gjs-sluglofty'] && attr['data-gjs-sluglofty'].value === 'paymentMethodDiv') {
          return {
            type: opts.name,
          };
        }
      } catch (error) {
        //
      }
    },

    view: defaultView.extend({
      init({model}) {
        this.listenTo(model, '', this.updateButtonState());
        this.listenTo(model, 'change:methodPayFunction', this.seekData);
      },
      async updateButtonState() {
        try {
          if (this.model.attributes.sluglofty.includes('paymentMethodDiv')) {
            await getPaymentMethods(this.model);
            if (this.model.attributes.methodPayFunction) {
              await RestoreVarData(this.model);
            }
          }
        } catch (error) {
          // console.log(error);
        }
      },
      async seekData() {
        try {
          if (this.model.attributes.sluglofty.includes('paymentMethodDiv')) {
            restoreComponentToDefault(this.model);
            this.model.removeTrait('cartMethodPay');
            this.model.removeTrait('listVariablesPay');
            this.model.removeTrait('serviceVarManage');
            await SeekInformationForFields(this.model);
          }
        } catch (error) {
          //
        }
      },
    }),
  });
};
